import { Authorized } from '@/react/hooks/useUser';
import { Authorizations } from '@/react/portainer/rbac/authorizations';

import { AddButton as BaseAddButton } from '@@/buttons';

export function AddButton() {
  return (
    <Authorized
      authorizations={Authorizations.Portainer.Registry.Create}
      adminOnlyCE
    >
      <BaseAddButton
        data-cy="registry-addRegistryButton"
        to="portainer.registries.new"
      >
        Add registry
      </BaseAddButton>
    </Authorized>
  );
}
